import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useAppContext } from '../../contexts/ThemeContext';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Button, 
  Menu, 
  MenuItem, 
  Avatar, 
  Box,
  Divider 
} from '@mui/material';
import { 
  Menu as MenuIcon, 
  LogOut, 
  User, 
  Settings
} from 'lucide-react';
import { Link } from 'react-router-dom';

function Header() {
  const { currentUser, logout } = useAuth();
  const { toggleDrawer } = useAppContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleLogout = async () => {
    try {
      await logout();
      setAnchorEl(null);
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky" elevation={1}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            onClick={toggleDrawer}
            edge="start"
            sx={{ 
              mr: 2,
              color: 'text.primary'
            }}
          >
            <MenuIcon size={24} />
          </IconButton>
          
          <Typography 
            variant="h5" 
            component={Link} 
            to="/" 
            sx={{ 
              textDecoration: 'none', 
              color: 'primary.main', 
              fontWeight: 'bold'
            }}
          >
            Garnii
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {currentUser && (
            <>
              {/* Desktop */}
              <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                <Avatar 
                  sx={{ 
                    bgcolor: 'primary.main',
                    width: 36,
                    height: 36,
                    fontSize: '0.875rem',
                    fontWeight: 'bold'
                  }}
                >
                  {currentUser.email.charAt(0).toUpperCase()}
                </Avatar>
                <Typography variant="body2" color="text.secondary">
                  {currentUser.email}
                </Typography>
                <Button 
                  onClick={handleLogout}
                  variant="outlined"
                  startIcon={<LogOut size={16} />}
                  size="small"
                >
                  Déconnexion
                </Button>
              </Box>

              {/* Mobile */}
              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  onClick={handleMenuOpen}
                  color="inherit"
                >
                  <Avatar 
                    sx={{ 
                      bgcolor: 'primary.main',
                      width: 32,
                      height: 32,
                      fontSize: '0.75rem'
                    }}
                  >
                    {currentUser.email.charAt(0).toUpperCase()}
                  </Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={isMenuOpen}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem disabled>
                    <Typography variant="body2" color="text.secondary">
                      {currentUser.email}
                    </Typography>
                  </MenuItem>
                  <Divider />
                  <MenuItem component={Link} to="/profile" onClick={handleMenuClose}>
                    <User size={18} style={{ marginRight: 8 }} />
                    Profil
                  </MenuItem>
                  <MenuItem component={Link} to="/settings" onClick={handleMenuClose}>
                    <Settings size={18} style={{ marginRight: 8 }} />
                    Paramètres
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogout}>
                    <LogOut size={18} style={{ marginRight: 8 }} />
                    Déconnexion
                  </MenuItem>
                </Menu>
              </Box>
            </>
          )}

          {!currentUser && (
            <Button 
              component={Link} 
              to="/login" 
              variant="contained"
            >
              Connexion
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;